import type { RequestContext } from "../context/request-context.js";
import type { NdtAssetService } from "./ndt-asset-service.js";

/** IDs de instrumentos selecionados nos relatórios END; não confundir com TAG do equipamento inspecionado. */
export function selectedNdtAssetIds(report: object): string[] {
  const data = report as Record<string, unknown>;
  const values: unknown[] = [
    data["deviceAssetId"], data["transducerAssetId"],
    data["calibrationBlockAssetId"], data["yokeAssetId"]
  ];
  if (Array.isArray(data["transducers"])) {
    for (const item of data["transducers"]) {
      if (item && typeof item === "object") values.push((item as { assetId?: unknown }).assetId);
    }
  }
  return [...new Set(values.filter((value): value is string => typeof value === "string" && value.trim().length > 0))];
}

/**
 * Validação de liberação, no servidor: nenhuma dependência da interface.
 * Não altera rascunhos nem documentos assinados; verifica apenas IDs efetivamente selecionados.
 */
export function createNdtReportAssetValidator(service: NdtAssetService) {
  return async (context: RequestContext, report: object): Promise<string[]> => {
    const ids = selectedNdtAssetIds(report);
    const data = report as Record<string, unknown>;
    const date = typeof data["testDate"] === "string" && data["testDate"].trim() ? data["testDate"] : undefined;
    const problems: string[] = [];
    for (const id of ids) {
      try {
        const asset = await service.getAsset(context, id);
        const decision = await service.validateAssetUsage(context, id, date);
        if (!decision.allowed) {
          problems.push(`O instrumento ${asset.internalCode || asset.serialNumber || id} está indisponível para uso na data do ensaio. Confira o estado e a calibração antes da liberação.`);
        }
      } catch (error) {
        problems.push(`Não foi possível validar o instrumento ${id} no cadastro END.`);
      }
    }
    return problems;
  };
}
